module.exports = __webpack_public_path__ + "static/media/fruit-ballet-3.e2afbeaf.png";